import React from 'react';
import i18n from "i18next";
import ConceptScheme from './ConceptScheme';

/** Отображение  таксономии на основе SKOS. Для отбражения используется список ConceptScheme, которые содержат набор концептов.
 * Для отображения передаётся URI схемы
 * Пример элемента списка:
 * { "IRI": { "type": "uri", "value": "http://csi.semanticpro.org/authority/domain" }	, "Label": { "type": "literal", "xml:lang": "ru", "value": "domain" }},
*/
class Taxonomy extends React.Component {	

  render() {
    const {taxonomy, onChange} = this.props;
    //const taxonomy = null;
    //Формируем массив доступных схем, описание схемы берём из taxonomy
    //console.log(this);
    const countSchemes = taxonomy
      ? taxonomy.filter(schema => schema["context"]==="undefined" || schema["context"]=="THEME").length 
      : 0;
    return (
      <span className="csi_taxonomy" >
        {!taxonomy && i18n.t('components.skos.taxonomy_not_loaded') }
        {taxonomy && taxonomy.filter(
            schema => schema["context"]==="undefined" || schema["context"]=="THEME"
          ).map((schema, i) =>  
            <ConceptScheme key={i} schema={schema} onChange={onChange} expand={countSchemes==1}/>
        )}
      </span>
    )
  }
}

export default Taxonomy;